// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"j9-z"};